module.exports = "https://d2jau2w7zc1e7m.cloudfront.net/packs/a6137456ed160d7606981aa57c559898.png";